import { useEffect } from 'react'
import { toastStore } from 'shared/ui'
import { WebsocketEvent } from 'entities/WebSocket/store'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type IResponseEventAccessRequestRevoked } from 'entities/Users/api/types'

type IHandlerEvent = (data: IResponseEventAccessRequestRevoked) => void

export const useEventAccessRequestRevoked = (handler?: IHandlerEvent) => {
  const { websocket } = useEntitiesContext()

  const defaultHandler = (data: IResponseEventAccessRequestRevoked) => {
    toastStore.add({
      type: 'error',
      title: 'Your request was declined',
    })

    handler?.(data)
  }

  useEffect(() => websocket.on(WebsocketEvent.AccessRequestRevoked, defaultHandler), [])
}
